import { z } from 'zod';

/** Numerische Pfad-ID. */
export const idParamSchema = z.object({
  id: z.coerce.number().int().positive(),
});

export const paginationSchema = z.object({
  limit: z.coerce.number().int().min(1).max(500).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});

export const sortOrderSchema = z.enum(['asc', 'desc']).default('asc');

/** Einheitliche Listenantwort — jede Liste der API sieht gleich aus. */
export function listResponse<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int(),
    rows: z.array(item),
  });
}

export const errorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});

export const okResponseSchema = z.object({ ok: z.literal(true) });

/** Datum ohne Uhrzeit, wie es in Formularen ankommt. */
export const dateOnlySchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Datum im Format JJJJ-MM-TT erwartet');

/**
 * Schreibende Massenoperationen laufen erst als Probelauf.
 * Ohne dieses Flag ändert keine Admin-Route etwas.
 */
export const dryRunSchema = z.object({
  dry_run: z.boolean().default(false),
});

export type Pagination = z.infer<typeof paginationSchema>;
